module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/31YzbsHk7mYWAQ6smGGA0o-7b51dc075a0c18d02cdb44ac51d18ab2.jpg";